import React from 'react'
import './typography.css'

const mainClass = "typography__main"
const renderDifferentText = (variant, mainClass, text) => {
	if (variant === "primary") {
		return (
				<h3 className={`${mainClass} typography__primary`}>{text}</h3>
		)
	} else if (variant === "secondary") {
		return (
			<span className={`${mainClass} typography__secondary`}>
				{text}
			</span>
		)
	} else if (variant === "dark-blue") {
		return (
			<span className={`${mainClass} typography__dark-blue`}>
				{text}
			</span>
		)
	} else return text;
}
function Typography({ variant = "primary", text, noWrapper=false, className = "", ...props }) {
	let mainClass = noWrapper?'':'typography__wrapper'
	mainClass = mainClass + " " + className

	// return renderDifferentText(variant, mainClass, text, props)
	return (
		<div className={mainClass} {...props} >
			{renderDifferentText(variant, mainClass, text)}
		</div>
	)
}

export default Typography


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Typography/index.js